export default class Placeholder {
  constructor(element) {
    this.element = element;
    this.element.setAttribute('placeholder', this.text);
  }

  get text() {
    let text = '';
    if (this.label) {
      text += this.label.innerText.replace(/[:*]/g, '');
    }
    return text;
  }

  get label() {
    return this.element.parentNode.querySelector('label');
  }
}
